import Select from 'react-select';
import {useState} from 'react';
import {
    Control,
    Path,
    PathValue,
    FieldValues,
    useController,
} from 'react-hook-form';
import {
    customStylesInputTeam,
    customStylesInput,
} from '../../../../configs/components/selectBoxStyle';
import * as styles from './selectBox.module.css';
import * as inputStyles from './input.module.css';

type SelectOption = {
    id?: string,
    value?: string | number | boolean,
    label?: string,
};

interface ISelectBoxProps<T extends FieldValues> {
    title: string,
    placeholder: string,
    control: Control<T>,
    defaultValue?: PathValue<T, Path<T>>,
    optionsValues?: SelectOption[],
    controllerName: Path<T>,
    required?: boolean,
    canType?: boolean,
    isDisabled?: boolean,
    setValueAs?: (value: SelectOption) => string | number | null,
    caption?: string,
}

const SelectBox = <T extends Record<string, any>>({
    title,
    placeholder,
    control,
    defaultValue = '' as PathValue<T, Path<T>>,
    optionsValues = [],
    controllerName,
    required = false,
    canType = false,
    isDisabled = false,
    setValueAs,
    caption,
}: ISelectBoxProps<T>) => {
    const [isLoading] = useState(false);
    const {
        field: {
            name,
            value = '' as string | string[] | Record<string, any>,
            onChange,
            ref,
        },
    } = useController({
        name: controllerName,
        control,
        rules: {
            required,
        },
        defaultValue,
    });

    const selectValue = () => {
        const filtered = optionsValues.filter(option => option.value === value)[0];

        if (filtered) {
            return filtered;
        }

        return 'undefined';
    };

    const handleOnChange = (option: SelectOption | any) => {
        if (setValueAs) {
            return onChange(setValueAs(option));
        }

        return onChange(option?.value || option);
    };

    return (
        <span className={styles.inputWrapper}>
            <span className={styles.title}>
                {title}
            </span>
            <Select
                name={name}
                ref={ref} // ref instead of inputRef to fix types, possibly broken?
                styles={controllerName === 'tag' ? customStylesInput : customStylesInputTeam}
                isClearable={true}
                isDisabled={isDisabled}
                isLoading={isLoading}
                options={optionsValues}
                value={selectValue() || 'undefined'}
                isSearchable={canType}
                placeholder={placeholder}
                onChange={handleOnChange}
            />
            <span className={inputStyles.messages}>{caption}</span>
        </span>
    );
};

export default SelectBox;
